









import Vue from 'vue'
import { apiRoutes } from '@/helpers/ApiRoutes'
import { SIMULATOR } from '@/views/Login.vue'

export default Vue.extend({
  name: 'Logout',

  async created () {
    const simulator = sessionStorage.getItem(SIMULATOR)
    if (simulator) {
      await this.$router.push({ name: 'Home' })
      return
    }
    try {
      await this.$axios.get(apiRoutes.apiLogout)
    } catch (e) {
      // Logout will throw a 401, which is fine but no need to log it
    }
    localStorage.clear()
    sessionStorage.clear()
    const logoutUrl = this.$axios.defaults.baseURL + apiRoutes.pwaLogout
    window.open(logoutUrl, '_self')
  }
})
